module.exports = __webpack_public_path__ + "static/media/lora-wordmark-dark.8385160a.svg";